var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-code',{attrs:{"title":"Actualizar Configuración"}},[_c('b-card-body',[(_vm.accessPermissions('configuration.show'))?_c('FormCreateComponent',{attrs:{"id":_vm.id}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }